module.exports = __webpack_public_path__ + "img/stock7.b0302df3.png";